"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Automatic route tracking for DataDog RUM
 * Use in app-shell MFEs only to prevent duplicate tracking across multiple MFEs
 */

import { useEffect, useState } from 'react';
import { registerAsRouteTracker, trackDataDogView } from './manualRouteTracking';

/**
 * Track route changes in DataDog RUM
 * App-shell MFEs only - implements global coordination to prevent duplicates
 */
export const useDataDogRouteTracking = location => {
  const [isRouteTracker] = useState(() => registerAsRouteTracker(__GDU_APP_NAME__));
  useEffect(() => {
    var _GDU_APP_NAME__;
    if (!isRouteTracker) return;
    trackDataDogView(location.pathname, {
      service: (_GDU_APP_NAME__ = __GDU_APP_NAME__) === null || _GDU_APP_NAME__ === void 0 ? void 0 : _GDU_APP_NAME__.replace('@autoguru/', ''),
      context: {
        fullPath: location.pathname,
        mfeAppName: __GDU_APP_NAME__
      }
    });
  }, [location.pathname, isRouteTracker]);
};